import {Asset} from '../models/asset';
import {Security} from '../models/security';

export enum AssetType {
    BASE  = 'BASE',
    QUOTE = 'QUOTE'
}

export function getSecurityAssetByType(security: Security, assetType: AssetType): Asset {
    return security && (
        assetType === AssetType.BASE
            ? security.baseAsset
            : security.quoteAsset
    );
}

export const getOppositeAssetType = (assetType: AssetType): AssetType =>
    assetType === AssetType.BASE
        ? AssetType.QUOTE
        : AssetType.BASE;
